<template>
	<el-drawer :title="drawerTitle" :visible.sync="visible" @close='comStateClose' size="40%" :close-on-click-modal="false" :close-on-press-escape="false"  :wrapper-closable="false"
		id="comDrawer">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerItem">
					<div class="drawerItemL">头像:</div>
					<div style="width:80px;height: 80px;border: 1px solid gray;">
						<img :src="avatarPic" @click="openUpload" style="width:100%;height: 100%;object-fit: cover;">
					</div>
					<input type="file" style="width:0;height: 0;" ref="file" @change="changeFile" />
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">姓名:</div>
					<el-input type="text" size="small" placeholder="请输入姓名" v-model="realName" style="width: 200px;">
					</el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">登录账号:</div>
					<el-input type="text" size="small" placeholder="请输入登录账号" v-model="userName" style="width: 200px;">
					</el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">性别:</div>
					<el-radio-group v-model="sex" size="small">
						<el-radio label="男">男</el-radio>
						<el-radio label="女">女</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">手机号:</div>
					<el-input type="text" size="small" placeholder="请输入手机号" v-model="userMobile" style="width: 200px;">
					</el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">职位:</div>
					<el-select v-model="position" placeholder="请选择职位" size="small" style="width: 200px;">
						<el-option v-for="item in positionList" :key="item._id" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">从业时间:</div>
					<el-input type="text" size="small" placeholder="请输入从业时间" v-model="employmentTimes" style="width: 200px;">
					</el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">介绍:</div>
					<el-input type="textarea" :rows="2" resize="none" size="small" placeholder="请输入介绍" v-model="introduce"
						style="width: 80%;"></el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">擅长:</div>
					<el-select v-model="specialityList" placeholder="请选择擅长" size="small" multiple style="width: 80%;">
						<el-option v-for="item in speciality" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">状态:</div>
					<el-radio-group v-model="status" size="small">
						<el-radio :label="1">在职</el-radio>
						<el-radio :label="0">离职</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">是否配送:</div>
					<el-radio-group v-model="canDistribution" size="small">
						<el-radio :label="0">不配送</el-radio>
						<el-radio :label="1">配送</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">是否登录:</div>
					<el-radio-group v-model="canLoginO2O" size="small">
						<el-radio :label="0">不允许</el-radio>
						<el-radio :label="1">允许</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">是否预约:</div>
					<el-radio-group v-model="isYuYue" size="small">
						<el-radio :label="0">不预约</el-radio>
						<el-radio :label="1">预约</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">APP是否显示:</div>
					<el-radio-group v-model="appShowStatus" size="small">
						<el-radio :label="0">不显示</el-radio>
						<el-radio :label="1">显示</el-radio>
					</el-radio-group>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">角色:</div>
					<el-select v-model="system_role" value-key="value" @change="handelSearchClick($event)"
						placeholder="请选择角色" size="small" style="width: 80%;">
						<el-option v-for="item in RoleList" :key="item.value" :label="item.title + ''" :value="item">
							<span style="float: left">{{ item.title }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.remark }}</span>
						</el-option>
					</el-select>

				</div>
				<div class="drawerItem">
					<div class="drawerItemL">所属门店:</div>
					<el-select v-model="ownerShopId" placeholder="请选择所属门店" size="small" style="width: 200px;">
						<el-option v-for="item in storeList" :key="item.shop_id" :label="item.shop_name"
							:value="item.shop_id">
						</el-option>
					</el-select>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">参与门店:</div>
					<el-select v-model="joinShopIds" placeholder="请选择参与门店" size="small" multiple style="width: 80%;">
						<el-option v-for="item in storeList" :key="item.shop_id" :label="item.shop_name"
							:value="item.shop_id">
						</el-option>
					</el-select>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">系统门店:</div>
					<el-select v-model="systemShopIds" placeholder="请选择系统门店" size="small" multiple style="width: 80%;">
						<el-option v-for="item in storeList" :key="item.shop_id" :label="item.shop_name"
							:value="item.shop_id">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="comStateClose">取消</div>
				<div class="btn" @click="handleSubmitClick">保存</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
export default {
	props: {
		comState: { //显示状态
			default: false
		},
		navData: {
			default() {
				return {}
			}
		},
		navType: {
			default: 0, //0新增 1编辑
		}
	},
	data() {
		return {
			canLoginO2O: 0,
			isYuYue:0,
			appShowStatus:0,
			avatarPic: '',
			visible: true,
			count: 1, //数量
			sfaffList: [], //员工列表
			staffId: '',
			editType: '0',
			remark: '',
			num: 1,
			lastCount: 0, //剩余数量
			drawerTitle: '',
			canDistribution: 0,//配送
			status: 1, //状态
			sex: '男', //性别
			ownerShopId: '', //所属门店
			storeList: [], //门店列表
			realName: '', //姓名
			userName: '', //登录账号
			userMobile: '', //手机号
			employmentTimes:'',//从业时间
			introduce: '', //介绍
			specialityList: [], //介绍
			speciality: [
				{
					value: '外科',
					label: '外科'
				}, {
					value: '骨科',
					label: '骨科'
				}, {
					value: '眼科',
					label: '眼科'
				}, {
					value: '牙科',
					label: '牙科'
				}, {
					value: '皮肤科',
					label: '皮肤科'
				}, {
					value: '肿瘤科',
					label: '肿瘤科'
				}, {
					value: '神经科',
					label: '神经科'
				}, {
					value: '麻醉科',
					label: '麻醉科'
				}, {
					value: '影像科',
					label: '影像科'
				}, {
					value: '心脏科',
					label: '心脏科'
				}, {
					value: '内科',
					label: '内科'
				}, {
					value: '急诊科',
					label: '急诊科'
				},
			],
			joinShopIds: [], //参与门店
			systemShopIds: [], //系统门店
			systemRole: {
				title: '',
				value: '',
				remark: ''
			},
			system_role: '', //角色
			RoleList: [],//角色列表
			departments: [],
			position: '', //职位
			positionList: [],
			defaultProp: {
				value: 'id',
				label: 'label',
				children: 'children'
			},
			keyword: '',
			state: -1, //角色 -1全部；0未启用；1已启用
			pageSize: 100,
			pageIndex: 0,

		}
	},
	watch: {
		// 监视状态发生改变
		comState() {
			this.visible = this.comState;
		},
	},
	mounted() {
		this.getPositionData()
		this.getDepartData()
		this.getStoreData()
		this.getRoleData()
		if (this.navType == 0) {
			this.drawerTitle = '新建员工'
		} else {
			this.drawerTitle = '编辑员工';
			let navData = this.navData;
			console.log(navData, 'navData');
			this.avatarPic = navData.avatarPic;
			this.canLoginO2O = navData.canLoginO2O;
			this.appShowStatus=navData.appShowStatus;
			this.isYuYue=navData.isYuYue;
			this.realName = navData.realName;
			this.userName = navData.userName;
			this.sex = navData.sex;
			this.userMobile = navData.userMobile;
			this.employmentTimes=navData.employmentTimes;
			this.introduce = navData.introduce;
			this.specialityList = navData.specialityList;
			this.status = navData.status;
			this.canDistribution = navData.canDistribution
		
			this.position = navData.position;
			this.systemRole = navData.systemRole;
			this.system_role = navData.systemRole.title;
			this.ownerShopId = navData.ownerShopId;
			this.joinShopIds = navData.joinShopIds;
			if (navData.systemShopIds == null) {
				this.systemShopIds = []
			} else {
				this.systemShopIds = navData.systemShopIds;
			}
		}
	},
	methods: {
		handelSearchClick(event) {
			this.systemRole = event
			this.system_role = event.title
		},
		//获取部门
		getDepartData() {
			this.$http.get(process.env.VUE_APP_Url2 + 'api/depart/tree').then(res => {
				if (res.code == 0) {
					console.log(res, 'bumen');
					this.departments = res.data;
				}
			})
		},
		//获取门店
		getStoreData() {
			let params = {
				companyId: '5e9412e0b2bfbc030160bdd5'
			}
			this.$http.get(process.env.VUE_APP_Url2 + 'api/CompanyInfo/shoplist', params).then(res => {
				if (res.code == 0) {
					// console.log('门店', res)
					this.storeList = res.data
				}
			})
		},
		//获取员工列表
		getPositionData() {
			this.$http.post(process.env.VUE_APP_Url2 + 'api/dict/StaffType/list').then(res => {
				if (res.code == 0) {
					// console.log('职位', res)
					this.positionList = res.data.data
				}
			})
		},
		//获取角色列表
		getRoleData() {
			let params = {
				keyword: this.keyword,
				state: this.state,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize
			}
			this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/role/list', params).then(res => {
				if (res.code == 0) {
					res.data.list.map((item) => {
						this.RoleList.push({ title: item.title, value: item.id, remark: item.remark })
					})
					console.log('角色', this.RoleList)
				}
			})
		},
		//保存
		handleSubmitClick() {
			if (this.realName == '') {
				this.$message({
					type: 'error',
					message: '请输入姓名'
				})
				return
			}
			if (this.userName == '') {
				this.$message({
					type: 'error',
					message: '请输入登录账号'
				})
				return
			}
			if (this.userMobile == '') {
				this.$message({
					type: 'error',
					message: '请输入输入手机号'
				})
				return
			}
			
			if (this.position == '') {
				this.$message({
					type: 'error',
					message: '请选择职位'
				})
				return
			}
			if (this.system_role == null) {
				this.$message({
					type: 'error',
					message: '请选择角色'
				})
				return
			}
			if (this.ownerShopId == '') {
				this.$message({
					type: 'error',
					message: '请选择所属门店'
				})
				return
			}
			if (this.joinShopIds.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择参与门店'
				})
				return
			}
			if (this.systemShopIds.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择系统门店'
				})
				return
			}
			if(this.system_role=='医生'&&this.specialityList.length==0){
				this.$message({
					type: 'error',
					message: '医生请选择擅长'
				})
				return
			}

			let params = {
				avatarPic: this.navType === 0 ? '' : this.avatarPic,
				userName: this.userName,
				userMobile: this.userMobile,
				employmentTimes:this.employmentTimes,
				realName: this.realName,
				sex: this.sex,
				canLoginO2O: this.canLoginO2O,
				appShowStatus:this.appShowStatus,
				isYuYue:this.isYuYue,
				departmentId: this.departmentId,
				joinShopIds: this.joinShopIds,
				ownerShopId: this.ownerShopId,
				introduce: this.introduce,
				specialityList: this.specialityList,
				position: this.position,
				systemShopIds: this.systemShopIds,
				status: this.status,
				canDistribution: this.canDistribution
			}
			params.systemRole = {
				title: this.systemRole.title,
				value: this.systemRole.value
			}
			if (this.navType == 0) {
				params.id = ''
			} else {
				params.id = this.navData.id
			}
			// params.departmentId = this.departmentIds[this.departmentIds.length - 1];
			// params.departmentId = this.departmentId;
			console.log(params, typeof (this.systemRole), "params")
			this.$http.post(process.env.VUE_APP_Url2 + 'api/StaffInfo/update', params).then(
				res => {
					if (res.code == 0) {
						if (this.navType == 0) {
							this.$message({
								type: 'success',
								message: '已新建'
							})
						} else {
							this.$message({
								type: 'success',
								message: '已修改'
							})
						}
						this.$emit("closeOn", {
							type: 'submit'
						});
					}
				})

		},
		//向父组件发射关闭弹框
		comStateClose() {
			this.$emit("closeOn", {
				type: 'close'
			});
		},
		// 修改头像
		openUpload() {
			this.$refs.file.click();
		},
		changeFile(e) {
			let fileList = e.target.files;
			let formData = new FormData();
			let ext = fileList[0].name.substr(fileList[0].name.lastIndexOf(".") + 1);
			if (ext === 'png' || ext === 'jpg' || ext === 'jpeg') {
				formData.append('img', fileList[0])
			} else {
				this.$message({
					message: '只能上传jpeg,jpg,png格式的文件',
					type: 'error'
				});
				return
			}
			let obj = {
				"dir": 'staffImg',
				"saveFileName": this.navData.id + ".jpg"
			}
			this.$util.uploadImg_dir(formData, obj).then(data => {


				console.log(data)
				this.avatarPic = data.url

			})
			this.$refs.file.value = null
		},
	},

}
</script>

<style scoped lang="scss">
#comDrawer {
	::v-deep .el-drawer__header {
		padding: 20px;
		margin-bottom: 0;
	}

	::v-deep .el-drawer__body {
		height: calc(100% - 65px);
		overflow-y: auto;
	}
}

.drawerView {
	height: 100%;

	.drawerViewT {
		height: calc(100% - 60px);
		box-sizing: border-box;
		border-top: solid 1px #F2F2F2;
		overflow-y: scroll;
		padding: 0 20px;

		.drawerItem {
			display: flex;
			align-items: center;
			margin-top: 20px;

			.drawerItemL {
				width: 80px;
				font-weight: bold;
				font-size: 14px;
				text-align: right;
				margin-right: 12px;
			}
		}

		.drawerItem2 {
			display: flex;
			margin-top: 20px;

			.drawerItemL {
				width: 80px;
				font-weight: bold;
				font-size: 14px;
				text-align: right;
				margin-right: 12px;
				line-height: 30px;
			}
		}

		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}

		.avatar-uploader-icon {
			border: 1px dashed #d9d9d9;
			font-size: 28px;
			color: #8c939d;
			width: 104px;
			height: 104px;
			line-height: 104px;
			text-align: center;
			border-radius: 10px;
		}

		.avatar {
			width: 104px;
			height: 104px;
			display: block;
			object-fit: cover;
			border: 1px dashed #d9d9d9;
			border-radius: 10px;
		}
	}

	.drawerViewT::-webkit-scrollbar {
		display: none;
	}

	.drawerViewB {
		height: 60px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0 20px;
		border-top: solid 1px #F2F2F2;
		box-sizing: border-box;

		.btn {
			width: 98px;
			line-height: 40px;
			text-align: center;
			background: #F58B2F;
			border-radius: 10px;
			font-size: 16px;
			font-weight: bold;
			color: #fff;
			cursor: pointer;
			margin-left: 20px;
		}

		.btn2 {
			width: 98px;
			line-height: 40px;
			text-align: center;
			background: #E3E3E3;
			border-radius: 10px;
			font-size: 16px;
			font-weight: bold;
			color: #666;
			cursor: pointer;
		}
	}
}
</style>
